// TEMPLATE TODO: update path and action type
export const apiPath = '/v2/webhook_settings';
const actionType = 'WEBHOOK_SETTINGS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
